import { Entitlement } from '@global/requests/entitlements';
import { createSlice } from '@reduxjs/toolkit';
import { getEntitlements } from './extraReducers/getEntitlements';
import { RootState } from '../../store';

export interface EntitlementsState {
  loading: boolean;
  error: boolean;
  errorMessage?: string;
  entitlements: Entitlement[];
}

export const initialState: EntitlementsState = {
  loading: false,
  error: false,
  errorMessage: undefined,
  entitlements: [],
};

export const entitlementsSlice = createSlice({
  name: 'entitlements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getEntitlements.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = undefined;
    });
    builder.addCase(getEntitlements.fulfilled, (state, { payload }) => {
      state.entitlements = payload;
      state.loading = false;
      state.error = false;
    });
    builder.addCase(getEntitlements.rejected, (state, { payload }) => {
      state.error = true;
      state.errorMessage = payload;
      state.loading = false;
    });
  },
});

export const entitlementsSelector = (state: RootState) => state.entitlements;
export const entitlementsReducer = entitlementsSlice.reducer;
